module.exports = __webpack_public_path__ + "static/media/department.144519b8.svg";